import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Teams from "./pages/Teams";
import Folders from "./pages/Folders";
import DocumentTypes from "./pages/DocumentTypes";
import OcrRules from "./pages/OcrRules";
import DocumentExplorer from "./pages/DocumentExplorer";
import UploadCenter from "./pages/UploadCenter";
import OcrQueue from "./pages/OcrQueue";
import SearchPage from "./pages/Search";
import DeletionApprovals from "./pages/DeletionApprovals";
import AuditLogs from "./pages/AuditLogs";
import EmailIntakeSimulator from "./pages/EmailIntakeSimulator";
import "@/index.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/explorer" element={<ProtectedRoute><DocumentExplorer /></ProtectedRoute>} />
          <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />

          <Route path="/upload" element={
            <ProtectedRoute roles={["super_admin", "team_admin", "scanner"]}>
              <UploadCenter />
            </ProtectedRoute>
          } />
          <Route path="/ocr-queue" element={
            <ProtectedRoute roles={["super_admin", "team_admin", "scanner"]}>
              <OcrQueue />
            </ProtectedRoute>
          } />
          <Route path="/email-intake" element={
            <ProtectedRoute roles={["super_admin", "team_admin", "scanner"]}>
              <EmailIntakeSimulator />
            </ProtectedRoute>
          } />
          <Route path="/folders" element={
            <ProtectedRoute roles={["super_admin", "team_admin"]}>
              <Folders />
            </ProtectedRoute>
          } />
          <Route path="/deletion-approvals" element={
            <ProtectedRoute roles={["super_admin", "team_admin"]}>
              <DeletionApprovals />
            </ProtectedRoute>
          } />

          <Route path="/users" element={
            <ProtectedRoute roles={["super_admin"]}>
              <Users />
            </ProtectedRoute>
          } />
          <Route path="/teams" element={
            <ProtectedRoute roles={["super_admin", "team_admin"]}>
              <Teams />
            </ProtectedRoute>
          } />
          <Route path="/document-types" element={
            <ProtectedRoute roles={["super_admin"]}>
              <DocumentTypes />
            </ProtectedRoute>
          } />
          <Route path="/ocr-rules" element={
            <ProtectedRoute roles={["super_admin"]}>
              <OcrRules />
            </ProtectedRoute>
          } />
          <Route path="/audit" element={
            <ProtectedRoute roles={["super_admin"]}>
              <AuditLogs />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
